export const SIDEBAR_WIDTH_EXPANDED = '280px'
export const SIDEBAR_WIDTH_CLOSED = '90px'
export const INPUT_HEIGHT = {
  regular: '38px',
  small: '25px'
}
